import type { StateCreator } from 'zustand';

export interface SessionUserSliceState {
  hasNoValidGroups: boolean;
  setHasNoValidGroups: (hasNoValidGroups: boolean) => void;
  hasOnlyGroupsWithNoVehicles: boolean;
  setHasOnlyGroupsWithNoVehicles: (hasOnlyGroupsWithNoVehicles: boolean) => void;
}

type StateCreatorSesionUser = StateCreator<SessionUserSliceState>;

const initialStates = {
  hasNoValidGroups: false,
  hasOnlyGroupsWithNoVehicles: false,
};

const createSessionUserSlice: StateCreatorSesionUser = (set) => ({
  ...initialStates,
  setHasNoValidGroups: (hasNoValidGroups: boolean) => set({ hasNoValidGroups }),
  setHasOnlyGroupsWithNoVehicles: (hasOnlyGroupsWithNoVehicles: boolean) => set({ hasOnlyGroupsWithNoVehicles }),
});

export default createSessionUserSlice;
